import axios from "Services/api";
import axios2 from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";


export const getCommon = createAsyncThunk("common/getCommonData", async () => {
  try {
    const response = await axios.get(`/GetCommonData`);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const getLanguages = createAsyncThunk("common/getLanguages", async () => {
  try {
    const response = await axios.get(`/GetLanguages`);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const getLocation = createAsyncThunk("common/getLocation", async () => {
  try {
    const response = await axios2(`https://ipapi.co/json`);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const getStreakTiming = createAsyncThunk("dashboard/getStreakTiming", async (thunkAPI) => {
  try {
    const response = await axios.get(`/GetStreakTiming`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});